<ng-content/>

<div class="custom-table"
		 [class.toggled]="toggleStates()['companySummary']">
	<div class="custom-table-header company-summary flex-between" (click)="toggleTableBody('companySummary')">
		<div class="custom-table-header-cell flex-left">
			<p>Company Information</p>
		</div>
		<button class="flex-center">
			<app-icon [icon]="toggleStates()['companySummary'] ? faAngleDownIcon : faAngleUpIcon"/>
		</button>
	</div>

	<div class="custom-table-body company-details">
		@if (companyDetails().company_name) {
			<div class="custom-table-row flex-left company-name">
				<p class="custom-table-cell">Company Name:</p>
				<p class="custom-table-cell">{{ companyDetails().company_name }}</p>
			</div>
		}
		@if (companyDetails().registration_number) {
			<div class="custom-table-row flex-left registration-number">
				<p class="custom-table-cell">Registration Number:</p>
				<p class="custom-table-cell">{{ companyDetails().registration_number }}</p>
			</div>
		}
		@if (companyDetails().tax_number) {
			<div class="custom-table-row flex-left tax-number">
				<p class="custom-table-cell">Tax Number:</p>
				<p class="custom-table-cell">{{ companyDetails().tax_number }}</p>
			</div>
		}
		<div class="custom-table-row flex-left financial-year-end">
			<p class="custom-table-cell">Financial Year End:</p>
			<p class="custom-table-cell">{{ companyDetails().financial_year_end }}</p>
		</div>

		<div class="custom-table-row flex-left authorized-shares">
			<p class="custom-table-cell">Authorised Shares:</p>
			<p class="custom-table-cell">{{ companyDetails().authorised_shares }}</p>
		</div>

		@if (companyDetails().phone) {
			<div class="custom-table-row flex-left phone-number">
				<p class="custom-table-cell">Phone Number:</p>
				<p class="custom-table-cell">{{ companyDetails().phone }}</p>
			</div>
		}
		<div class="custom-table-row flex-left email-address">
			<p class="custom-table-cell">Email Address:</p>
			<p class="custom-table-cell">{{ companyDetails().email }}</p>
		</div>
		@if (companyDetails().website) {
			<div class="custom-table-row flex-left website">
				<p class="custom-table-cell">Website:</p>
				<p class="custom-table-cell">{{ companyDetails().website }}</p>
			</div>
		}
		<div class="custom-table-row flex-left physical-address">
			<p class="custom-table-cell">Physical Address:</p>
			<p class="custom-table-cell" [innerHTML]="(companyDetails().physicalAddress ?? {}) | addressToString">
			</p>
		</div>
		<div class="custom-table-row flex-left postal-address">
			<p class="custom-table-cell">Postal Address:</p>
			<p class="custom-table-cell" [innerHTML]="(companyDetails().postalAddress ?? {}) | addressToString">
			</p>
		</div>
	</div>
</div>

<!-- DIRECTOR INFORMATION -->
<div class="custom-table director-information"
		 [class.toggled]="toggleStates()['directorSummary']">
	<div class="custom-table-header director-summary  flex-between" (click)="toggleTableBody('directorSummary')">
		<div class="custom-table-header-cell flex-left">
			<p>Director Information</p>
		</div>
		<button class="flex-center">
			<app-icon [icon]="toggleStates()['directorSummary'] ? faAngleDownIcon : faAngleUpIcon"/>
		</button>
	</div>

	<div class="custom-table-body">
		@for (director of directorsDetails(); track director.id_number) {
			<div class="custom-table-row flex-left full-name">
				<p class="custom-table-cell">Full Name:</p>
				<p class="custom-table-cell">{{ director.first_name }} {{ director.surname }}</p>
			</div>
			@if (director.citizen) {
				<div class="custom-table-row flex-left identity">
					<p class="custom-table-cell">ID Number:</p>
					<p class="custom-table-cell">{{ director.id_number }}</p>
				</div>
			} @else {
				<div class="custom-table-row flex-left identity">
					<p class="custom-table-cell">Passport Number:</p>
					<p class="custom-table-cell">{{ director.id_number }}</p>
				</div>
				<div class="custom-table-row flex-left date-of-birth">
					<p class="custom-table-cell">Date of Birth:</p>
					<p class="custom-table-cell">{{ director.date_of_birth }}</p>
				</div>
				<div class="custom-table-row flex-left country-of-origin">
					<p class="custom-table-cell">Country of Origin:</p>
					<p class="custom-table-cell">{{ director.country_of_origin }}</p>
				</div>
			}
			@if (director.ownership) {
				<div class="custom-table-row flex-left ownership">
					<p class="custom-table-cell">Ownership:</p>
					<p class="custom-table-cell">{{ director.ownership }}%</p>
				</div>
			}
			<div class="custom-table-row flex-left director-phone-number">
				<p class="custom-table-cell">Phone Number:</p>
				<p class="custom-table-cell">{{ director.phone }}</p>
			</div>
			<div class="custom-table-row flex-left director-email">
				<p class="custom-table-cell">Email Address:</p>
				<p class="custom-table-cell">{{ director.email }}</p>
			</div>
			<div class="custom-table-row flex-left director-residential-address">
				<p class="custom-table-cell">Residential Address:</p>
				<p class="custom-table-cell" [innerHTML]="(director.residentialAddress ?? {}) | addressToString">
				</p>
			</div>
			<div class="custom-table-row flex-left director-postal-address">
				<p class="custom-table-cell">Postal Address:</p>
				<p class="custom-table-cell" [innerHTML]="(director.postalAddress ?? {}) | addressToString">
				</p>
			</div>

			@if ($index !== directorsDetails().length - 1) {
				<hr class="separator"/>
			}
		}
	</div>
</div>
